import { createSlice } from '@reduxjs/toolkit';
import { Slices } from 'ducks/slices';
import { User } from 'ducks/types/store-types';
import { deleteStorage } from 'utils/storage';

import { getUser } from './operators';

const initialState: User = {
  authentication_result: 0,
  error: '',
  email_address: '',
  display_name: '',
  public_key: '',
  private_key: '',
  organization_name: '',
  role_name: '',
  uuid: '',
};

const userSlice = createSlice({
  name: Slices.USER,
  initialState,
  reducers: {
    setUser: (_state, action) => {
      return action.payload;
    },
    clearUser: () => {
      deleteStorage();
      return { ...initialState };
    },
    updateUser: (state, { payload }) => {
      state.display_name = payload.display_name;
      state.email_address = payload.email_address;
    },
  },
  // removed the rejected case because authentication will never reject
  // we capture the error and populate that in the login
  extraReducers: (builder) => {
    builder.addCase(getUser.pending, () => {
      return { ...initialState };
    });
  },
});

export const { clearUser, setUser, updateUser } = userSlice.actions;

export default userSlice.reducer;
